import Vue from 'vue'

Vue.component('cmp-mde-warehouse-detail', require('./cmp-mde-warehouse-form').default)
Vue.component('cmp-mde-currency-detail', require('./cmp-mde-currency-form').default)
Vue.component('cmp-mde-customer-detail', require('./cmp-mde-customer-form').default)
Vue.component('cmp-mde-supplier-detail', require('./cmp-mde-supplier-form').default)
